// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  subscriptionDetails: Object,
};

const DeleteSelectedSubscription = (props: Props) => {
  const {
    visible,
    close,
    submit,
    subscriptionDetails,
  } = props;

  const deleteSelectedSubscription = () => {
    submit(subscriptionDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      title="Cancel Subscription"
      footer={[
        <SpButton onClick={() => close()} type="secondary">No, dont cancel</SpButton>,
        <SpButton onClick={deleteSelectedSubscription} type="danger">Yes, cancel</SpButton>,
      ]}
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to cancel this Subscription?</h6>
        <SpH5 className="pb-3">
          <div>{subscriptionDetails.customer.name ? subscriptionDetails.customer.name : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedSubscription;
